import { RegionAPI } from '../../../api/datamanager/RegionAPI';

export class RegionsCommand {
    getAll(provider, successCallback, errorCallback) {
        let apiResult = undefined;
        
        if(undefined === provider || null === provider || '' === provider) {
            apiResult = RegionAPI.list();
        }
        else {
            apiResult = RegionAPI.listTA(provider);
        }
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a ler as Regiões");
            }
        });
    }

    getByLine(networkEdition, line, provider, successCallback, errorCallback) {
        let apiResult = RegionAPI.listByLine(networkEdition, line, provider);
        // if(Array.isArray(networkEdition)) {
        //     apiResult = RegionAPI.lisyByLineDraft(line, provider);
        // }
        // else {
        //     apiResult = RegionAPI.listByLine(line, provider)
        // }

        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a ler as Regiões da Linha selecionada");
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/commands/RegionsCommand.js